<!-- <body class="main">
    <div class="headerContainer">
        <div>
            <img style="width: 15vh;" src="../../../../assets/image/registrationLogo.png" alt="">
        </div>
        <div class="headerContent">
            <span class="headerName">Registration</span>
        </div>
    </div>
    <div class="content">
        <div class="section">
            <label for="" class="text">Full Name</label>
            <input class="input" type="text">
        </div>
        <div class="section">
            <label for="" class="text">Email Address</label>
            <input class="input" type="text">
        </div>
        <div class="section">
            <label for="" class="text">Mobile Number</label>
            <input class="input" type="text">
        </div>
        <div class="section">
            <label for="" class="text">Purpose</label>
            <input class="input" type="text">
        </div>
        <div class="section">
            <label for="" class="text">Message</label>
            <input class="input" type="text">
        </div>
    </div>
</body> -->

<body class="main">
    <div class="titleContainer" *ngIf="show">
        <img src="../../../../assets/image/registrationLogo.png" alt="" width="65px">
        <span class="tiltetext">
            <span>Sri Chaitanya</span>
            <span>Employee Connect</span>
        </span>
    </div>
    <div class="data"  *ngIf="show">
        <span class="dataTitle">
        <span>Request Access to </span>
        <span>Sri Chaitanya Employee </span>
        <span>Connect</span>
        </span>
        <!-- <span class="dataContent">
            <span>Fill in your details below .</span>
            <span>Our support name will recieve your require </span>
        </span> -->
    </div>
    <div class="detailsContainer"  *ngIf="show">
        <div class="section">
            <label for="" class="text">Full Name <span style="color: orange;">*</span></label>
            <input class="input" type="text" (input)="getName($event)">
        </div>
        <div class="section">
            <label for="" class="text" >Email Address  <span style="color: orange;">*</span></label>
            <input class="input" type="text" (input)="getemail($event)">
        </div>
        <div class="section">
            <label for="" class="text">Mobile Number  <span style="color: orange;">*</span></label>
            <input class="input" type="text" (input)="restrictToNumbers($event)" (input)="getmobile($event)" maxlength="10" minlength="10">
        </div>
        <!-- <div class="section">
            <label for="" class="text">Purpose  <span style="color: orange;">*</span></label>
            <input class="input" type="text" (input)="getpurpose($event)">
        </div> -->
        <div class="section">
            <label for="" class="text">Message (optional)</label>
            <input class="input" type="text">
        </div>
           <div class="section">
            <button class="button" (click)="submit()">Submit Request </button>
        </div>
    </div>
    <span *ngIf="!show" class="dataContent" style="height:90vh;display: flex;justify-content: center;align-items: center;font-size: 18px;">
        <span style=" font-weight: 600;font-size: 38px;">Thank you! </span>
        <span>Our team will review your request  </span>
        <span>contact you shortly.</span>
    </span>
    
</body>